import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import {
  GET,
  CREATE,
  MARK_UNREAD,
  MARK_AS_SEEN
} from '@hobs/constants/discussion';

export function getDiscussion(serviceRequestId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `ServiceRequests/${serviceRequestId}/Discussion?skip=0&take=1000`
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, payload: response.payload };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }
  function success(payload) {
    return { type: GET.SUCCESS, payload };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function sendMessage(serviceRequestId, message) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`ServiceRequests/${serviceRequestId}/Discussion`, {
      body: { message },
      method: 'POST'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: CREATE.REQUEST };
  }
  function success(payload) {
    return { type: CREATE.SUCCESS, payload };
  }
  function failure(error) {
    return { type: CREATE.FAILURE, error };
  }
}

export function markUnread(serviceRequestId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `ServiceRequests/${serviceRequestId}/Discussion/MarkAsUnread`,
      { method: 'POST' }
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: MARK_UNREAD.REQUEST };
  }
  function success() {
    return { type: MARK_UNREAD.SUCCESS };
  }
  function failure(error) {
    return { type: MARK_UNREAD.FAILURE, error };
  }
}

export function resetDiscussion() {
  return {
    type: GET.RESET
  };
}

export function markAsSeen(serviceRequestId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `ServiceRequests/${serviceRequestId}/Discussion/MarkAsSeen`,
      { method: 'POST' }
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error));
        return { success: false, error: error.toString() };
      });
  };

  function request() {
    return { type: MARK_AS_SEEN.REQUEST };
  }
  function success() {
    return { type: MARK_AS_SEEN.SUCCESS };
  }
  function failure(error) {
    return { type: MARK_AS_SEEN.FAILURE, error };
  }
}
